import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { useVisibleTools } from '@/lib/tools'
import { useUi } from '@/lib/i18n/ui'

export const Route = createFileRoute('/tools/')({
  component: ToolsIndex,
})

function ToolsIndex() {
  const tools = useVisibleTools()
  const ui = useUi()
  return (
    <div className="mx-auto max-w-5xl px-6 pb-20 pt-12">
      <p className="text-sm font-semibold text-violet-600">
        {ui.toolsEyebrow}
      </p>
      <h1 className="mt-3 text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
        {ui.toolsTitle}
      </h1>
      <p className="mt-4 max-w-2xl text-lg leading-relaxed text-slate-500">
        {ui.toolsIntro}
      </p>

      <ul className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {tools.map(t => (
          <li key={t.slug}>
            <Link
              to={t.to}
              className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-5 transition-shadow hover:shadow-md"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
                <t.icon className="h-6 w-6" />
              </span>
              <h2 className="mt-4 text-lg font-semibold leading-snug text-slate-900">
                {t.label}
              </h2>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{t.body}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-violet-600">
                {t.available ? ui.openTool : ui.preview}
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
